import { CLEAR_DATA, SET_CHARACTER, SET_ISLOGGED_IN, SET_TOKEN, SET_USER } from './types.js'

export default {
    [SET_TOKEN] (state , payload) {
      state.authToken = payload
    },
    [SET_USER] (state , payload) {
      state.user = payload
    },
    [SET_CHARACTER] (state , payload) {
      state.characters = payload
    },
    [SET_ISLOGGED_IN] (state , payload) {
      state.isLoggedIn = payload
    },
    [CLEAR_DATA] (state) {
      const data = {
        authToken: '',
        isLoggedIn: false,
        user: null,
        characters: null
      }


      Object.assign(state, data)
    }
}